module.exports = __webpack_public_path__ + "static/media/InfoIntox.e207d992.jpg";